import { render } from "./CIS-FAQ-Item-Headline.vue?vue&type=template&id=3e839304"
import script from "./CIS-FAQ-Item-Headline.vue?vue&type=script&lang=js"
export * from "./CIS-FAQ-Item-Headline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__